import { FunctionComponent, useMemo } from 'react';
import { DateText } from './DateText';
import { Temporal } from 'temporal-polyfill';
import { PublicOccurrence } from '@cademy-package/sdk-component-types';

type OccurrenceDateTimeLabelProps = {
    occurrence: PublicOccurrence;
};

export const OccurrenceDateTimeLabel: FunctionComponent<OccurrenceDateTimeLabelProps> = ({
    occurrence,
}) => {
    const startDate = useMemo(
        () => Temporal.ZonedDateTime.from(occurrence.times.start.zoned_datetime),
        [occurrence]
    );
    const endDate = useMemo(
        () => Temporal.ZonedDateTime.from(occurrence.times.end.zoned_datetime),
        [occurrence]
    );

    const doesSpanMultipleDays = useMemo(() => {
        const sameDay = startDate.toPlainDate().equals(endDate.toPlainDate());

        return !sameDay;
    }, [startDate, endDate]);

    return (
        <DateText
            startDate={startDate}
            endDate={endDate}
            doesSpanMultipleDays={doesSpanMultipleDays}
        />
    );
};
